class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack};
/* tjs <- make-error.ts */

/* line 1 */
function stringify(x) {
  try {
  __tjs.pushStack('make-error.ts:1:stringify');
  if (x instanceof Error) return x;

    try {
        return JSON.stringify(x);
    }
    catch (_) {
        return '{has circular references}';
    }

  } finally { __tjs.popStack(); }
}
stringify.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "make-error.ts:1"
}

/* line 9 */
export function makeError(...messages) {
  try {
  __tjs.pushStack('make-error.ts:14:makeError');
  if (messages instanceof Error) return messages;
  if (messages !== undefined && !Array.isArray(messages)) return __tjs.typeError('make-error.ts:14:makeError.messages', 'array', messages);

    return new Error(messages.map(stringify).join(' '));

  } finally { __tjs.popStack(); }
}
makeError.__tjs = {
  "params": {
    "messages": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": false
    }
  },
  "source": "make-error.ts:14"
}